import { render, staticRenderFns } from "./RecevabiliteDesDemandes.vue?vue&type=template&id=748f2caf&"
import script from "./RecevabiliteDesDemandes.vue?vue&type=script&lang=js&"
export * from "./RecevabiliteDesDemandes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports